import { render, staticRenderFns } from "./RgRadio.vue?vue&type=template&id=4fdf0e19&scoped=true&"
import script from "./RgRadio.vue?vue&type=script&lang=js&"
export * from "./RgRadio.vue?vue&type=script&lang=js&"
import style0 from "./RgRadio.vue?vue&type=style&index=0&id=4fdf0e19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf0e19",
  null
  
)

export default component.exports